import { IHierarchyNode } from '../api-client/models/hierarchy-node';
import { ArgumentValidator } from './argument-validator';

export class HierarchyFinder {

    public static find<T>(nodes: IHierarchyNode<T>[], func: (node: IHierarchyNode<T>) => boolean): IHierarchyNode<T> | undefined{

        const allNodes = this.allNodes(nodes);

        return allNodes.find(x => func(x));
    }

    public static findNext<T>(nodes: IHierarchyNode<T>[], node: IHierarchyNode<T>): IHierarchyNode<T> | undefined{

        const allNodes = this.allNodes(nodes);

        const currentIndex = allNodes.findIndex(x => x.uri === node.uri);

        const nextIndex = currentIndex + 1;

        if (!allNodes[nextIndex]) {
            return undefined;
        }

        return allNodes[nextIndex];
    }

    public static findPrevious<T>(nodes: IHierarchyNode<T>[], node: IHierarchyNode<T>): IHierarchyNode<T> | undefined{

        const allNodes = this.allNodes(nodes);

        const currentIndex = allNodes.findIndex(x => x.uri === node.uri);

        const previous = currentIndex - 1;

        if (!allNodes[previous]) {
            return undefined;
        }

        return allNodes[previous];
    }

    public static filter<T>(nodes: IHierarchyNode<T>[], func: (node: IHierarchyNode<T>) => boolean): IHierarchyNode<T>[] | undefined{

        const allNodes = this.allNodes(nodes);

        return allNodes.filter(x => func(x));
    }

    public static findAncestors<T>(nodes: IHierarchyNode<T>[], node: IHierarchyNode<T>): IHierarchyNode<T>[] {

        const allNodes = this.allNodes(nodes);

        return allNodes.filter(x => node.uri.toLowerCase().startsWith(x.uri.toLowerCase()));
    }

    public static allNodes<T>(nodes: IHierarchyNode<T>[]): IHierarchyNode<T>[] {

        const allNodes: IHierarchyNode<T>[] = [];

        nodes.forEach((node: IHierarchyNode<T>) => {

            allNodes.push(...this.allNodesFromTopNode(node));
        });

        return allNodes;
    }

    public static allNodesFromTopNode<T>(node: IHierarchyNode<T>): IHierarchyNode<T>[] {

        const allNodes: IHierarchyNode<T>[] = [
            node
        ];

        if (node == null || node.nodes == null || node.nodes.length === 0) {

            return allNodes;
        }

        node.nodes.forEach((subNode: IHierarchyNode<T>) => {

            allNodes.push(...this.allNodesFromTopNode(subNode));
        });

        return allNodes;
    }

    public static hierarchyWalker<T>(nodes: IHierarchyNode<T>[],
        onEach: (node: IHierarchyNode<T>) => void,
        ignorePath?: (node: IHierarchyNode<T>) => boolean): void {

        ArgumentValidator.notNullOrEmpty(nodes, `originNode`);

        ArgumentValidator.notNullOrEmpty(onEach, `onEach`);

        nodes.forEach(node => {

            if (ignorePath !== undefined && ignorePath(node)) {
                return;
            }

            onEach(node);

            if (node.nodes) {
                this.hierarchyWalker(node.nodes, onEach, ignorePath);
            }
        });
    }
}
